import React, {Component} from 'react';
import { Table, Form, Button, InputGroup, FormControl } from 'react-bootstrap'

export default class Trivia extends Component {
    constructor(props) {
        super(props);
        this.state = {
            triviaDataArray:[{ 
            }]
        }
    }

    handleNextPrev = (val) => {
        const { activeStep } = this.state;
        let updatedActiveStep = activeStep + val
        updatedActiveStep = updatedActiveStep < 1 ? 1 : updatedActiveStep > 3 ? 3 : updatedActiveStep;
        this.setState({ activeStep: updatedActiveStep })
    }
    handleRemoveRow = async (id) => {
        let newDataArray = [...this.state.triviaDataArray]
        newDataArray.splice(id,1)
        await this.setState({ triviaDataArray: newDataArray })
    }
    handleAddRow = async () => {
        let newDataArray = [...this.state.triviaDataArray]
        newDataArray.push({
            itemName: "",
            image: "",
            attr1: "",
            attr2: "",
            attr3: "",
        })
        await this.setState({ triviaDataArray: newDataArray }) 
    }


    render() {
        const { triviaDataArray } = this.state;
        return (
            <div className="gs-container">
                <Table responsive>
                    <thead>
                        <tr>
                            <th>Compose</th>
                            <th>Schedule</th>
                            <th>Time</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            triviaDataArray.map((item, id) =>
                                <tr key={id}>
                                    <td><Form.Control type="text" placeholder={"Trivia " + (id + 1)} /></td>
                                    <td>
                                        <InputGroup className="mb-3">
                                            <FormControl type="date" />
                                            <InputGroup.Append>
                                                <InputGroup.Text id="basic-addon2"><i className="fas fa-calendar"></i></InputGroup.Text>
                                            </InputGroup.Append>
                                        </InputGroup>
                                    </td>
                                    <td>
                                        <InputGroup className="mb-3">
                                            <FormControl type="time" />
                                            <InputGroup.Append>
                                                <InputGroup.Text id="basic-addon2"><i className="fas fa-clock"></i></InputGroup.Text>
                                            </InputGroup.Append>
                                        </InputGroup>
                                    </td>
                                    <td>
                                        <Button
                                            onClick={
                                                id === triviaDataArray.length - 1 ?
                                                    this.handleAddRow : () => this.handleRemoveRow(id)
                                            }
                                            block>
                                            <i
                                                className={
                                                    id === triviaDataArray.length - 1 ?
                                                        "fas fa-plus" : "fas fa-minus"
                                                }></i>
                                        </Button>
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </Table>
            </div>
        )
    }
}